import { useEffect, useState } from "react";
import axios from "axios";
import { Phone, CalendarCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MobileCallBar({ onBook }) {
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    axios.get(`${API}/next-slot`).then((r) => setSlot(r.data.slot)).catch(() => {});
  }, []);

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 border-t-[3px] border-tpeco-ink rounded-t-3xl overflow-hidden" data-testid="mobile-call-bar">
      <a href="tel:0475776555" className="flex items-center justify-center gap-2 bg-tpeco-pink text-white font-display uppercase text-xl py-3" data-testid="mobile-call-button">
        <Phone className="w-5 h-5" strokeWidth={2.5} /> CALL NOW
      </a>
      <button onClick={onBook} className="flex items-center justify-center gap-2 bg-tpeco-blue text-white font-display uppercase py-2" data-testid="mobile-book-button">
        <CalendarCheck className="w-5 h-5 shrink-0" strokeWidth={2.5} />
        {slot ? (
          <span className="flex flex-col items-start leading-none text-left">
            <span className="text-[0.6rem] tracking-[0.18em]" data-testid="mobile-next-slot-label">NEXT SLOT — BOOK IT</span>
            <span className="text-2xl tracking-wide" data-testid="mobile-next-slot-time">{slot}</span>
          </span>
        ) : (
          <span className="text-xl">BOOK ONLINE</span>
        )}
      </button>
    </div>
  );
}
